import React, { useState } from 'react';
import ViewAllTags from '../components/settings/ViewAllTags';
import { UserPen, Tag, Mail, Sparkles, Plug, Building2, Linkedin } from 'lucide-react';
import AccountInformation from '../components/settings/AccountInformation';
import EmailTemplatesPage from './EmailTemplatesPage';
import SummaryTemplates from '../components/settings/SummaryTemplates';
import IntegrationSettings from '../components/settings/IntegrationSettings';
import CompanySettings from '../components/settings/CompanySettings';
import LinkedInSettings from '../components/settings/LinkedInSettings';
import Breadcrumb from '../components/utils/Breadcrumb';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('information');

  const tabs = [
    {
      id: 'information',
      label: 'Informations',
      icon: <UserPen size={18} />,
      component: <AccountInformation />
    },
    {
      id: 'company',
      label: 'Entreprise',
      icon: <Building2 size={18} />,
      component: <CompanySettings />
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      icon: <Linkedin size={18} />,
      component: <LinkedInSettings />
    },
    {
      id: 'tags',
      label: 'Tags',
      icon: <Tag size={18} />,
      component: <ViewAllTags />
    },
    {
      id: 'email templates',
      label: 'Templates Email',
      icon: <Mail size={18} />,
      component: <EmailTemplatesPage />
    },
    {
      id: 'summary templates',
      label: 'Templates IA',
      icon: <Sparkles size={18} />,
      component: <SummaryTemplates />
    },
    {
      id: 'integration',
      label: 'Intégrations',
      icon: <Plug size={18} />,
      component: <IntegrationSettings />
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 pt-16 lg:pt-10">
      {/* Header avec breadcrumb et titre */}
      <div className="bg-white border-b border-gray-200 p-4 sm:p-6 lg:p-10">
        <Breadcrumb items={[
          { label: 'Dashboard', href: '/app', icon: 'bi-house' },
          { label: 'Paramètres', href: null, icon: 'bi-gear', isActive: true }
        ]} />
        <h1 className="text-2xl sm:text-3xl font-bold  text-slate-800 m-0">Paramètres</h1>
      </div>

      {/* Layout avec sidebar et contenu */}
      <div className="flex flex-col lg:flex-row">
        {/* Sidebar navigation - desktop/mobile */}
        <aside className="w-full lg:w-64 bg-white border-r border-gray-200 lg:min-h-screen">
          <div className="sticky top-16 p-4 lg:p-6">
            {/* Navigation verticale */}
            <nav className="space-y-1">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                  w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-sm transition-all duration-200
                  ${activeTab === tab.id
                      ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-md'
                      : 'text-slate-600 hover:bg-gray-50 hover:text-slate-800'
                    }
                `}
                >
                  <span className={activeTab === tab.id ? 'text-white' : 'text-slate-400'}>
                    {tab.icon}
                  </span>
                  <span>{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Contenu principal */}
        <main className="flex-1 p-4 sm:p-6 lg:p-10">
          <div className="max-w-full">
            {/* Titre mobile uniquement pour afficher le nom de l'onglet */}
            <h2 className="lg:hidden text-xl font-semibold mb-4 text-slate-800">
              {tabs.find(tab => tab.id === activeTab)?.label}
            </h2>

            {/* Contenu de l'onglet actif */}
            {tabs.find(tab => tab.id === activeTab)?.component}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Settings;